import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import { Route, useHistory } from '@treams/treams-routes';

import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';
import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';
import Button, { ButtonSize } from 'packages/kakapo-ui-kit/components/editors/Button';
import SubheaderNavigationLink, {
	SubheaderNavigationLinkSize,
} from 'packages/kakapo-ui-kit/components/navigation/SubheaderNavigationLink';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';

const LearningHeader = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const authenticatedUser = useAuthenticatedUser();

	const roles = useViewerRoles();

	const canReview = roles.isWorkspaceSuperuser || roles.isLearningOfficer;

	return (
		<>
			<Flex flexGrow={1} alignItems="center" justifyContent="space-between">
				<Flex alignItems="center">
					<Box mr={4}>
						<PersonAvatar size={PersonAvatarSize.Medium} person={authenticatedUser} />
					</Box>
					<Route
						path={['/learning', '/learning/event/:id', '/learning/calendar/:year/:month']}
						exact
					>
						{({ match }) => (
							<SubheaderNavigationLink
								size={SubheaderNavigationLinkSize.Large}
								title={t('learning.events.navigation.upcomingEvents')}
								to="/learning"
								isActive={!!match}
							/>
						)}
					</Route>
					<Route path="/learning/me" exact>
						{({ match }) => (
							<SubheaderNavigationLink
								size={SubheaderNavigationLinkSize.Large}
								title={t('learning.events.navigation.myEvents')}
								to="/learning/me"
								isActive={!!match}
							/>
						)}
					</Route>
					{canReview && (
						<Route path="/learning/proposals" exact>
							{({ match }) => (
								<SubheaderNavigationLink
									size={SubheaderNavigationLinkSize.Large}
									title={t('learning.events.navigation.proposedEvents')}
									to="/learning/proposals"
									isActive={!!match}
								/>
							)}
						</Route>
					)}
					<Route path="/learning/certificates" exact>
						{({ match }) => (
							<SubheaderNavigationLink
								size={SubheaderNavigationLinkSize.Large}
								title={t('learning.events.navigation.certificates')}
								to="/learning/certificates"
								isActive={!!match}
							/>
						)}
					</Route>
				</Flex>

				<Button
					size={ButtonSize.Medium}
					onClick={() => {
						history.push({
							pathname: '/learning/event/create',
							state: {
								backgroundLocation: history.location,
							},
						});
					}}
				>
					{t('learning.events.navigation.createEvent')}
				</Button>
			</Flex>
			<HorizontalRule />
		</>
	);
};

export default LearningHeader;
